/**
 * "Available (lbs)" cell of the desktop check-inventory table: the batch's quantity, read as being
 * in the selected quantity UOM, converted to pounds with `getTotalQuantityInLB`
 * (`components/Shared/MoreYouBuyMoreYouSave`) and truncated to two decimals. Empty for the
 * placeholder row.
 */
import { truncateNumber } from "@components/Helper/common";
import { getTotalQuantityInLB } from "@components/Shared/MoreYouBuyMoreYouSave";
import { UOM } from "@ryerson/common.enums";
import { Product } from "@ryerson/frontend.common";
import { Flex } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import React from "react";

interface CheckInventoryModalTableQtyAvailableInPoundProps {
	rowData: any;
	qtyUom: string;
	product: Product;
	priceUom: string;
}

/** The row's `quantityAvailable` in `qtyUom`, converted to pounds for `product`. */
const CheckInventoryModalTableQtyAvailableInPound: React.FC<
	CheckInventoryModalTableQtyAvailableInPoundProps
> = ({ rowData, qtyUom, product, priceUom }) => {
	const { theme } = useTheme();
	const { darkGray } = theme.colors.primary;

	return (
		<Flex justifyContent="flex-end" alignItems="center">
			<Typography color={darkGray}>
				{rowData.quantityAvailable &&
					truncateNumber(
						Number(
							getTotalQuantityInLB(
								qtyUom as UOM,
								rowData.quantityAvailable,
								product,
								priceUom as UOM
							)
						),
						2
					)}
			</Typography>
		</Flex>
	);
};

export default CheckInventoryModalTableQtyAvailableInPound;
